import { getStoreItem } from '../store';

const store = getStoreItem('store');
const template = store?.template;
const lang = store?.lang;
const tempwords = template?.words?.[lang];
const options = template?.options;

// TODO: to be removed
export const roles = [
  {
    branchName: { type: String },
    isBranchAdmin: { type: Boolean },
    systems: [
      {
        systemName: { type: String },
        isSystemAdmin: { type: Boolean },
        levels: {
          view: { type: Boolean },
          add: { type: Boolean },
          edit: { type: Boolean },
          delete: { type: Boolean },
          report: { type: Boolean },
        },
      },
    ],
  },
];
// TODO: to be removed
export const rolesExample = {
  branchs: [
    {
      name: 'branch1',
      isAdmin: true,
      systems: [
        {
          name: 'system1',
          isAdmin: true,
          levels: {
            view: true,
            add: true,
            edit: true,
            delete: true,
            report: true,
          },
        },
      ],
    },
  ],
};
// TODO: to be checked
export const packages = [
  {
    name: 'free',
    title: 'Free',
    titleAr: 'الحزمة المجانية',
    eventsQty: 100,
    durationQty: -1,
    docsQty: 500,
    cost: 0,
    users: 1,
    smss: 0,
    emails: 0,
  },
  {
    name: 'basic',
    title: 'Basic',
    titleAr: 'الحزمة الأساسية',
    eventsQty: 1500,
    docsQty: 5000,
    durationQty: 1,
    durationType: 'y',
    cost: 1000,
    users: 3,
    smss: 100,
    emails: 1000,
  },
  {
    name: 'standard',
    title: 'Standard',
    titleAr: 'الحزمة القياسية',
    eventsQty: 4500,
    docsQty: 15000,
    durationQty: 1,
    durationType: 'y',
    cost: 1400,
    users: 10,
    smss: 250,
    emails: 2500,
  },
  {
    name: 'premium',
    title: 'Premium',
    titleAr: 'الحزمة الممتازة',
    eventsQty: 9000,
    docsQty: -1,
    durationQty: 1,
    durationType: 'y',
    cost: 1800,
    users: 20,
    smss: 500,
    emails: 5000,
  },
  {
    name: 'custom',
    title: 'Custom',
    titleAr: 'الحزمة المخصصة',
    eventsQty: -1,
    docsQty: -1,
    durationQty: 1,
    durationType: 'y',
    cost: 1800,
    users: -1,
    smss: 500,
    emails: 5000,
  },
];
export const newrolestemplate = [
  {
    name: 'home',
    top: true,
    ref: 'opr',
    titleAr: 'الرئيسية',
    titleEn: 'Home',
    view: false,
  },
  {
    name: 'calendar',
    top: true,
    ref: 'opr',
    titleAr: 'التقويم',
    titleEn: 'Calendar',
    hide: !options?.calendar,
    view: false,
  },
  {
    top: true,
    name: 'formdocs',
    ref: 'opr',
    titleAr: `النماذج`,
    titleEn: `Forms`,
    hide: !options?.formdocs,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'letters',
    ref: 'opr',
    titleAr: `الخطابات`,
    titleEn: `Letters`,
    hide: !options?.letters,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'presales',
    ref: 'opr',
    titleAr: `قبل البيع`,
    titleEn: `Presales`,
    hide: !options?.presales,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'operations',
    ref: 'opr',
    titleAr: `العمليات`,
    titleEn: `Operations`,
    hide: !options?.operations,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'approvals',
    ref: 'opr',
    titleAr: `الاعتمادات`,
    titleEn: `Approvals`,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'sales',
    ref: 'opr',
    titleAr: `المبيعات`,
    titleEn: `Sales`,
    hide: !options?.sales,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'purchase',
    ref: 'opr',
    titleAr: `المشتريات`,
    titleEn: `Purchase`,
    hide: !options?.purchase,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'expenses',
    ref: 'opr',
    titleAr: `المصروفات`,
    titleEn: `Expenses`,
    hide: !options?.expenses,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'finance',
    ref: 'opr',
    titleAr: `الحسابات`,
    titleEn: `Finance`,
    hide: !options?.finance,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'mail',
    ref: 'opr',
    titleAr: `البريد`,
    titleEn: `Mail Mangment`,
    hide: !options?.mail,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'pos',
    ref: 'opr',
    titleAr: `نقطة البيع`,
    titleEn: `POS`,
    hide: !options?.pos,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'reports',
    ref: 'opr',
    titleAr: `التقارير`,
    titleEn: `Reports`,
    hide: !options?.reports,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'adds',
    ref: 'opr',
    titleAr: `الاضافات`,
    titleEn: `Basic Adds`,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'reminder',
    ref: 'opr',
    titleAr: `المفكرة`,
    titleEn: `Reminder`,
    hide: !options?.reminder,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'sms',
    top: true,
    ref: 'sms',
    titleAr: 'رسائل SMS',
    titleEn: 'SMS Messages',
    hide: !options?.sms,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'users',
    top: true,
    titleAr: 'المستخدمين',
    titleEn: 'Users',
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'notifications',
    top: true,
    ref: 'opr',
    titleAr: 'التنبيهات',
    titleEn: 'Notifications',
    view: false,
  },
  {
    name: 'options',
    top: true,
    ref: 'opr',
    titleAr: 'الاعدادات',
    titleEn: 'Options',
    view: false,
    edit: false,
    admin: false,
  },
];
export const badmintemplate = [
  {
    name: 'home',
    top: true,
    ref: 'opr',
    titleAr: 'الرئيسية',
    titleEn: 'Home',
    view: true,
  },
  {
    name: 'calendar',
    top: true,
    ref: 'opr',
    titleAr: 'التقويم',
    titleEn: 'Calendar',
    hide: !options?.calendar,
    view: true,
  },
  {
    name: 'formdocs',
    ref: 'opr',
    titleAr: `النماذج`,
    titleEn: `Forms`,
    hide: !options?.formdocs,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'letters',
    ref: 'opr',
    titleAr: `الخطابات`,
    titleEn: `Letters`,
    hide: !options?.letters,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'presales',
    ref: 'opr',
    titleAr: `قبل البيع`,
    titleEn: `Presales`,
    hide: !options?.presales,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'operations',
    ref: 'opr',
    titleAr: `المبيعات`,
    titleEn: `Sales`,
    hide: !options?.operations,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'approvals',
    ref: 'opr',
    titleAr: `الاعتمادات`,
    titleEn: `Approvals`,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'sales',
    ref: 'opr',
    titleAr: `العمليات`,
    titleEn: `Operations`,
    hide: !options?.sales,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'purchase',
    ref: 'opr',
    titleAr: `المشتريات`,
    titleEn: `Purchase`,
    hide: !options?.purchase,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'expenses',
    ref: 'opr',
    titleAr: `المصروفات`,
    titleEn: `Expenses`,
    hide: !options?.expenses,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'finance',
    ref: 'opr',
    titleAr: `الحسابات`,
    titleEn: `Finance`,
    hide: !options?.finance,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'mail',
    ref: 'opr',
    titleAr: `البريد`,
    titleEn: `Mail Mangment`,
    hide: !options?.mail,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'pos',
    ref: 'opr',
    titleAr: `نقطة البيع`,
    titleEn: `POS`,
    hide: !options?.pos,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'reports',
    ref: 'opr',
    titleAr: `التقارير`,
    titleEn: `Reports`,
    hide: !options?.reports,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'adds',
    ref: 'opr',
    titleAr: `الاضافات`,
    titleEn: `Basic Adds`,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'reminder',
    ref: 'opr',
    titleAr: `المفكرة`,
    titleEn: `Reminder`,
    hide: !options?.reminder,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'sms',
    top: true,
    ref: 'sms',
    titleAr: 'رسائل SMS',
    titleEn: 'SMS Messages',
    hide: !options?.sms,
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'users',
    top: true,
    titleAr: 'المستخدمين',
    titleEn: 'Users',
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  {
    name: 'notifications',
    top: true,
    ref: 'opr',
    titleAr: 'التنبيهات',
    titleEn: 'Notifications',
    view: true,
  },
  {
    name: 'options',
    top: true,
    ref: 'opr',
    titleAr: 'الاعدادات',
    titleEn: 'Options',
    view: true,
    edit: true,
    admin: true,
  },
];
export const employeetemplate = [
  {
    name: 'home',
    top: true,
    ref: 'opr',
    titleAr: 'الرئيسية',
    titleEn: 'Home',
    view: true,
  },
  {
    name: 'calendar',
    top: true,
    ref: 'opr',
    titleAr: 'التقويم',
    titleEn: 'Calendar',
    hide: !options?.calendar,
    view: true,
  },
  {
    name: 'tasks',
    top: true,
    ref: 'opr',
    titleAr: tempwords?.tasks,
    titleEn: tempwords?.tasks,
    hide: !options?.contract,
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'appointments',
    top: true,
    ref: 'opr',
    titleAr: tempwords?.appointments,
    titleEn: tempwords?.appointments,
    view: true,
    add: true,
    edit: true,
    delete: false,
    admin: false,
  },
  {
    name: 'invoices',
    ref: 'sal',
    titleAr: 'فواتير البيع',
    titleEn: 'Invoices',
    view: true,
    add: true,
    edit: true,
    delete: false,
    admin: false,
  },
  {
    name: 'receipts',
    ref: 'sal',
    titleAr: 'المقبوضات',
    titleEn: 'Receipts',
    view: true,
    add: true,
    edit: true,
    delete: false,
    admin: false,
  },
  {
    name: 'customers',
    ref: 'sal',
    titleAr: tempwords?.customers,
    titleEn: tempwords?.customers,
    view: true,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'managereminders',
    top: true,
    ref: 'sms',
    titleAr: 'المفكرة',
    titleEn: 'Reminders',
    view: false,
    add: false,
    edit: false,
    delete: false,
    admin: false,
  },
  {
    name: 'notifications',
    top: true,
    ref: 'opr',
    titleAr: 'التنبيهات',
    titleEn: 'Notifications',
    view: true,
  },
  {
    name: 'options',
    top: true,
    ref: 'opr',
    titleAr: 'الاعدادات',
    titleEn: 'Options',
    view: true,
    edit: false,
    admin: false,
  },
];
export const userrolesTypes = {
  home: { view: true },
  calendar: { view: true },
  formdocs: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  letters: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  presales: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  operations: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  approvals: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  sales: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  purchase: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  expenses: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  finance: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  mail: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  pos: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  reports: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  adds: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  reminder: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  sms: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  users: {
    view: true,
    add: true,
    edit: true,
    delete: true,
    admin: true,
  },
  notifications: {
    view: true,
  },
  options: {
    view: true,
    edit: true,
    admin: true,
  },
  isSuperAdmin: false,
  isBranchsAdmin: false,
  isBranchAdmin: false,
  isEmployee: false,
};
